import Vue from "vue";
import Vuex from "vuex";
//import VuexPersistence from 'vuex-persist'

import account from './module-account';
import addinvoiceitems from './module-addinvoiceitems';
import addtocatalog from './module-addtocatalog';
import addtocustomerorder from './module-addtocustomerorder';
import addtoproviderorder from './module-addtoproviderorder';
import addtoreceipt from './module-addtoreceipt';
import addtoshipment from './module-addtoshipment';
import adjuststock from './module-adjuststock';
import transferstock from './module-transferstock';
import agents from './module-agents';
import allocation from './module-allocation';
import allocations from './module-allocations';
import assigncatalog from './module-assigncatalog';
import assignedcatalog from './module-assignedcatalog';
import billingaccount from './module-billingaccount';
import billingaccounts from './module-billingaccounts';
import billingstats from './module-billingstats';
import browsecatalog from './module-browsecatalog';
import catalog from './module-catalog';
import catalogentry from './module-catalogentry';
import catalogs from './module-catalogs';
import commissions from './module-commissions';
import completecustomer from './module-completecustomer';
import connectors from './module-connectors';
import posSync from './module-pos-sync';
import contractline from './module-contractline';
import createordershipment from './module-createordershipment';
import customer from './module-customer';
import customercatalogs from './module-customercatalogs';
import customerinvoice from './module-customerinvoice';
import customerinvoices from './module-customerinvoices';
import customerorders from './module-customerorders';
import customers from './module-customers';
import deliverysite from './module-deliverysite';
import deliverysites from './module-deliverysites';
import downloads from './module-downloads';
import inappNotifications from './module-notifications';
import editagent from './module-editagent';
import editbillingaccount from './module-editbillingaccount';
import editcatalog from './module-editcatalog';
import editcustomer from './module-editcustomer';
import editcustomerinvoice from './module-editcustomerinvoice';
import editcustomerinvoiceitem from './module-editcustomerinvoiceitem';
import editcustomerproviderinvoice from './module-editcustomerproviderinvoice';
import editcustomerorder from './module-editcustomerorder';
import editdeliverysite from './module-editdeliverysite';
import editentity from './module-editentity';
import editestablishment from './module-editestablishment';
import extractionSession from './module-extraction-session';
import editorderitemcount from './module-editorderitemcount';
import editproduct from './module-editproduct';
import editproductlink from './module-editproductlink';
import editprospect from './module-editprospect';
import editprovider from './module-editprovider';
import editproviderinvoice from './module-editproviderinvoice';
import editproviderorder from './module-editproviderorder';
import editproviderproduct from './module-editproviderproduct';
import editreceipt from './module-editreceipt';
import editshipment from './module-editshipment';
import editstock from './module-editstock';
import entitycontacts from './module-entitycontacts';
import establishments from './module-establishments';
import establishment from './module-establishment';
import events from './module-events';
import globalsearch from './module-globalsearch';
import group from './module-group';
import help from './module-help';
import importproducts from './module-importproducts';
import inventory from './module-inventory';
import invitation from './module-invitation';
import invitations from './module-invitations';
import invitecustomer from './module-invitecustomer';
import inviteagent from './module-inviteagent';
import inviteprospect from './module-inviteprospect';
import inviteprovider from './module-inviteprovider';
import mcl from './module-mcl';
import missingreceiptitem from './module-missingreceiptitem';
import missingshipmentitem from './module-missingshipmentitem';
import movements from './module-movements';
import operators from './module-operators';
import customerorder from './module-customerorder';
import product from './module-product';
import products from './module-products';
import production from './module-production';
import productstrategy from './module-productstrategy';
import producttype from './module-producttype';
import producttypes from './module-producttypes';
import productSalesPrices from './module-product-sales-prices';
import productstoorder from './module-productstoorder';
import toorder from './module-toorder';
import provider from './module-provider';
import apPayment from './module-ap-payment';
import apPaymentQueue from './module-ap-payment-queue';
import apReview from './module-ap-review';
import apQueue from './module-ap-queue';
import providerinvoice from './module-providerinvoice';
import providerinvoices from './module-providerinvoices';
import providerorder from './module-providerorder';
import providerorders from './module-providerorders';
import providerproduct from './module-providerproduct';
import providers from './module-providers';
import shop from './module-shop';
import cart from './module-cart';
import cartNotification from './module-cart-notification';
import purchaseprices from './module-purchaseprices';
import radar from './module-radar';
import receipt from './module-receipt';
import receipts from './module-receipts';
import searchcatalog from './module-searchcatalog';
import salesinsights from './module-salesinsights';
import sendinvoice from './module-sendinvoice';
import sendorderinvoice from './module-sendorderinvoice';
import sendorderform from './module-sendorderform';
import session from './module-session';
import homeKpis from './module-home-kpis';
import swal from './module-swal';
import settings from './module-settings';
import shipment from './module-shipment';
import shipments from './module-shipments';
import stock from './module-stock';
import stocklocation from './module-stocklocation';
import stocks from './module-stocks';
import stockstats from './module-stockstats';
import synchronizeallocations from './module-synchronize-allocations';
import synchronizecatalog from './module-synchronize-catalog';
import synchronizeassignedcatalog from './module-synchronize-assignedcatalog';
import synchronizecustomers from './module-synchronize-customers';
import synchronizeproducts from './module-synchronize-products';
import synchronizeproviderproducts from './module-synchronize-providerproducts';
import synchronizeproviders from './module-synchronize-providers';
import synchronizestockproducts from './module-synchronize-stockproducts';
import synchronizebundles from './module-synchronize-bundles';
import synchronizedestock from './module-synchronize-destock';
import user from './module-user';
import users from './module-users';
import validateinvoice from './module-validateinvoice';
import zoneedit from './module-zone-edit';
import zones from './module-zones';
import performance from './module-performance';
import bundle from './module-bundle';
import bundles from './module-bundles';
import addestablishmentstoproduct from './module-addestablishmentstoproduct';
import editbundle from './module-editbundle';
import campaign from './module-campaign';
import campaigns from './module-campaigns';

Vue.use(Vuex);

const modules = {
    account,
    editagent,
    agents,
    addinvoiceitems,
    addtocatalog,
    addtocustomerorder,
    addtoproviderorder,
    addtoreceipt,
    addtoshipment,
    adjuststock,
    transferstock,
    allocation,
    allocations,
    assigncatalog,
    assignedcatalog,
    billingaccount,
    billingaccounts,
    billingstats,
    browsecatalog,
    campaign,
    campaigns,
    catalog,
    catalogentry,
    catalogs,
    completecustomer,
    contractline,
    createordershipment,
    customer,
    customercatalogs,
    customerinvoice,
    customerinvoices,
    customerorder,
    customerorders,
    customers,
    commissions,
    connectors,
    posSync,
    deliverysite,
    deliverysites,
    downloads,
    inappNotifications,
    editbillingaccount,
    editbundle,
    editcatalog,
    editcustomer,
    editcustomerorder,
    editdeliverysite,
    editentity,
    editcustomerinvoice,
    editcustomerinvoiceitem,
    editcustomerproviderinvoice,
    editorderitemcount,
    editestablishment,
    editproduct,
    editprovider,
    editproviderinvoice,
    editproviderorder,
    editproviderproduct,
    editreceipt,
    editshipment,
    editprospect,
    editproductlink,
    editstock,
    entitycontacts,
    establishments,
    establishment,
    events,
    extractionSession,
    globalsearch,
    group,
    help,
    importproducts,
    inventory,
    invitation,
    invitations,
    invitecustomer,
    inviteagent,
    inviteprovider,
    inviteprospect,
    mcl,
    missingreceiptitem,
    missingshipmentitem,
    movements,
    operators,
    product,
    products,
    production,
    productstrategy,
    producttype,
    producttypes,
    productSalesPrices,
    productstoorder,
    toorder,
    provider,
    apPayment,
    apPaymentQueue,
    apReview,
    apQueue,
    providerinvoice,
    providerinvoices,
    providerorder,
    providerorders,
    providerproduct,
    radar,
    providers,
    shop,
    cart,
    cartNotification,
    purchaseprices,
    receipt,
    receipts,
    searchcatalog,
    salesinsights,
    sendinvoice,
    sendorderinvoice,
    sendorderform,
    session,
    homeKpis,
    swal,
    settings,
    shipment,
    shipments,
    stock,
    stocklocation,
    stocks,
    stockstats,
    synchronizeallocations,
    synchronizeassignedcatalog,
    synchronizecatalog,
    synchronizecustomers,
    synchronizeproducts,
    synchronizeproviderproducts,
    synchronizeproviders,
    synchronizestockproducts,
    synchronizebundles,
    synchronizedestock,
    user,
    users,
    validateinvoice,
    zoneedit,
    zones,
    performance,
    bundle,
    bundles,
    addestablishmentstoproduct,
};

const state = {};

const mutations = {};

const actions = {};

// const vuexLocal = new VuexPersistence({
//   storage: window.localStorage
// })

const store = new Vuex.Store({
    modules,
    state,
    mutations,
    actions,
    plugins: [
        (store) => {
            // Listen to cart mutations to show notifications
            store.subscribe((mutation, state) => {
                if (mutation.type === 'cart/addDelta') {
                    const { providerId, item } = mutation.payload;
                    
                    // Extract deliverysiteId from item
                    const deliverysiteId = item.deliverysite || null;
                    const deliverysiteKey = deliverysiteId ? String(deliverysiteId) : 'null';
                    
                    // Use setTimeout to ensure the notification is shown after the mutation has updated cartsList
                    setTimeout(() => {
                        // Normalize catalogentry to number and string key
                        const catalogentry = typeof item.catalogentry === 'string' 
                            ? parseInt(item.catalogentry, 10) 
                            : item.catalogentry;
                        const catalogentryKey = String(catalogentry);
                        
                        // Find the cart for this provider and deliverysite
                        const cart = state.cart.cartsList.find(c => 
                            c.provider === providerId && 
                            (c.deliverysite === deliverysiteId || (c.deliverysite === null && deliverysiteId === null))
                        );
                        let notificationItem = null;
                        let itemIndex = -1;
                        
                        if (cart && cart.items) {
                            // Find item by catalogentry in cart
                            itemIndex = cart.items.findIndex(i => 
                                i.catalogentry === catalogentry
                            );
                            
                            if (itemIndex >= 0) {
                                notificationItem = cart.items[itemIndex];
                            }
                        }
                        
                        // If item not found in cart, check pending items
                        if (!notificationItem) {
                            const pendingItem = state.cart.pendingItems[providerId]?.[deliverysiteKey]?.[catalogentryKey];
                            if (pendingItem) {
                                notificationItem = {
                                    catalogentry: catalogentry,
                                    catalogentry_data: pendingItem.catalogentry_data || item.catalogentry_data,
                                    quantity: 0, // Not created yet
                                    count: 0,
                                };
                                itemIndex = -1; // Not in cart yet
                            }
                        }
                        
                        if (notificationItem) {
                            // Check if cart modal is open - don't show notification if it is
                            // The modal component is a function, so we check the function's string representation
                            const modal = state.mcl?.modal;
                            const isCartModalOpen = modal && 
                                modal.component && 
                                (typeof modal.component === 'function' 
                                    ? modal.component.toString().includes('modals/cart') || modal.component.toString().includes('@/modals/cart')
                                    : false);
                            
                            // Don't show notification if cart modal is open
                            if (isCartModalOpen) {
                                return;
                            }
                            
                            // Get pending quantity
                            const pendingQuantity = state.cart.pendingItems[providerId]?.[deliverysiteKey]?.[catalogentryKey]?.quantity || 0;
                            
                            // Convert to frontend format
                            const frontendItem = {
                                ...notificationItem,
                                quantity: notificationItem.count || notificationItem.quantity || 0,
                                pendingQuantity: pendingQuantity,
                                catalogentry_data: notificationItem.catalogentry_data || item.catalogentry_data,
                            };
                            
                            store.commit('cartNotification/showNotification', {
                                item: {
                                    ...frontendItem,
                                    deliverysite: deliverysiteId, // Store deliverysite in notification item
                                },
                                providerId,
                                itemIndex: itemIndex >= 0 ? itemIndex : 0, // Use 0 as fallback if not in cart
                                catalogentry: catalogentry,
                            });
                        }
                    }, 0);
                }
            });
        },
    ],
});

export default store;
